<!-- TODO - why are we making the whole card clickable? this means that any clickable element below has to manage event propagation -->
<forge-card #card class="no-padding" (click)="onCardClick()" [ngClass]="cardClasses" telemetry="Submission-SearchCard">

    @if (hasHeader) {
    <div fxFlex fxLayout="row" fxLayoutAlign="space-around center" [ngClass]="cardHeaderClasses"
        class="tt-card-header-container">
        <div fxFlex="auto" fxLayout="column">
            <span fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between center" class="min-width-0">
                <span fxLayout="row" fxLayoutAlign="start center" [ngClass]="headerGroupClasses">
                    @if (showAvatar) {
                    <card-avatar [item]="item" (click)="$event.stopPropagation()" style="padding-right: 18px;"
                        tabindex="-1" telemetry="Submission-StopProp">
                    </card-avatar>
                    }
                    <div fxFlex="auto" fxLayout="column" fxLayoutAlign="center start" class="truncate">
                        <div fxLayout="row" class="forge-typography--heading4">
                            @for (field of headerElements; track field) {
                            <div fxFlex fxLayout="row" [ngClass]="getHeaderElementClasses($last)">
                                @if (isAction(field)) {
                                <div (click)="performFieldCommand(field, $event)" [ngClass]="getClass(field)"
                                    class="truncate infocard-link" [attr.telemetry]="getHeaderActionAriaLabel(field)">
                                    {{getValue(field)}}
                                </div>
                                }
                                @if (!isAction(field)) {
                                <div [ngClass]="getClass(field)" class="truncate" [attr.telemetry]="field.Label">
                                    {{getValue(field)}}
                                </div>
                                }
                                @if (!$last) {
                                <div>&nbsp; &bull; &nbsp;</div>
                                }
                            </div>
                            }
                        </div>
                        @if (!isEmphasized && hasSubHeader) {
                        <div fxFlex="100" fxLayout="row">
                            @for (field of subHeaderElements; track field) {
                            <div fxFlex fxLayout="row" [ngClass]="getHeaderElementClasses($last)">
                                @if (isAction(field)) {
                                <div (click)="performFieldCommand(field, $event)" class="truncate"
                                    [ngClass]="getClass(field)" [attr.telemetry]="getHeaderActionAriaLabel(field)">
                                    {{getValue(field)}}
                                </div>
                                }
                                @if (!isAction(field)) {
                                <div [attr.telemetry]="field.Label" class="truncate" [ngClass]="getClass(field)">
                                    {{getValue(field)}}
                                </div>
                                }
                                @if (!$last) {
                                <div>&nbsp; &bull; &nbsp;</div>
                                }
                            </div>
                            }
                        </div>
                        }
                    </div>
                </span>
                @if (isCompact) {
                <span #compactDetail fxFlex fxLayout="row" fxLayoutAlign="end center">
                    @for (rows of getPrimaryFieldsForGroup(); track rows) {
                    <span class="primary-row" fxFlex fxLayout="row">
                        <info-card-detail-field fxFlex [itemMetadata]="item.Metadata" [rows]="rows"
                            [maxWidth]="getPrimaryFieldWidth()" (executeCommand)="performFieldCommand($event)">
                        </info-card-detail-field>
                    </span>
                    }
                    <chip-collection fxLayout="row" fxLayoutAlign="end end" [chips]="chips"
                        (click)="$event.stopPropagation()" class="zIndex2">
                    </chip-collection>
                    @for (cmd of iconCommands; track cmd) {
                    <forge-icon-button class="compact-commands">
                        <command [command]="cmd"></command>
                    </forge-icon-button>
                    }
                    <!-- TODO - refactor to edit command -->
                    @if (allowEdit) {
                    <forge-icon-button class="compact-commands" [disabled]="!allowEdit" (click)="onEdit($event)"
                        telemetry="Submission-Edit">
                        <forge-tooltip placement="bottom">Edit</forge-tooltip>
                        <forge-icon name="edit"></forge-icon>
                    </forge-icon-button>
                    }
                    <!-- TODO - refactor to delete command -->
                    @if (canDelete && allowDelete) {
                    <forge-icon-button class="compact-commands" [disabled]="!allowDelete" (click)="onDelete($event)"
                        telemetry="Submission-Delete">
                        <forge-tooltip placement="bottom">Delete</forge-tooltip>
                        <forge-icon name="delete"></forge-icon>
                    </forge-icon-button>
                    }
                    <div fxLayout="column" fxLayoutAlign="center end">
                        <!-- TODO - if we are always hiding the Chips, then we should replace this with a command-menu because that is all this is providing now... -->
                        @if (showVertMenu) {
                        <note-and-attachment [entity]="noteAttachmentEntity"
                            [disableAttachments]="!item.AllowAttachments" [disableNotes]="!item.AllowNotes"
                            [disabled]="!item.AllowAttachmentEdit" [hideChips]="true"
                            [hideSubject]="item.HideNoteSubject" [additionalCommands]="additionalCommands"
                            [chips]="chips" telemetry="Submission-ChipClick">
                        </note-and-attachment>
                        }
                    </div>
                </span>
                }
                @if (!isCompact) {
                <span fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <div class="info-card-title-field" fxFlex>{{item.TitleField}}</div>
                    <chip-collection fxLayout="row" fxLayoutAlign="end end" [chips]="chips"
                        (click)="$event.stopPropagation()" class="zIndex2">
                    </chip-collection>
                    <div fxLayout="column" fxLayoutAlign="center end" class="info-card-aggregates">
                        @for (field of item.AggregateElements; track field) {
                        <div fxFlex fxLayout="row" fxLayoutAlign="end center"
                            [ngStyle]="getAggregateElementColor(field)">
                            @if (field.Label) {
                            <div fxFlex="auto" fxLayoutAlign="end center">
                                {{field.Label}}:&nbsp;
                            </div>
                            }
                            <div fxFlex="auto" fxLayoutAlign="start center">{{field.Value}}</div>
                        </div>
                        }
                    </div>
                    <div fxFlex="5"></div>
                    <div fxLayout="row" fxLayoutAlign="end start">
                        @for (cmd of iconCommands; track cmd) {
                        <div>
                            <command [command]="cmd" (click)="$event.stopPropagation()"></command>
                        </div>
                        }
                    </div>
                    <!-- TODO - edit command -->
                    @if (editable) {
                    <forge-icon-button [disabled]="!allowEdit" (click)="toggleEditMode()" telemetry="Submission-Edit">
                        <forge-tooltip placement="bottom">Edit</forge-tooltip>
                        <forge-icon name="edit"></forge-icon>
                    </forge-icon-button>
                    }
                    <!-- TODO - no Delete when not compact? -->
                    <div fxLayout="column" fxLayoutAlign="center end">
                        <!-- TODO - if we are always hiding the Chips, then we should replace this with a command-menu because that is all this is providing now... -->
                        @if (showVertMenu) {
                        <note-and-attachment [entity]="noteAttachmentEntity" [additionalCommands]="additionalCommands"
                            [disableAttachments]="!item.AllowAttachments" [disableNotes]="!item.AllowNotes"
                            [disabled]="!item.AllowAttachmentEdit" [hideChips]="true"
                            [hideSubject]="item.HideNoteSubject" [chips]="chips" telemetry="Submission-ChipClick">
                        </note-and-attachment>
                        }
                    </div>
                </span>
                }
            </span>
        @if (isHeaderCustom && headerTemplate) {
          <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: item }"></ng-container>
        }
      </div>
    </div>
    }

    @if (isEmphasized && hasHeader) {
    <forge-divider></forge-divider>
    }

    <!-- TODO is this hidden if `!isEmphasized` -->
    @for (group of item.GroupDataElements; track group) {
    <div class="tt-card-body">
        <!-- TODO - flip to showTitle -->
        @if (!hideTitle(group.GroupName)) {
        <div class="forge-typography--heading2">
            {{group.GroupName}}
        </div>
        }
        <!-- TODO - flip boolean to showPrimaryDetail -->
        @if (!hidePrimaryDetail(group.GroupName)) {
        <div fxLayout="column" fxLayoutAlign="space-around" [ngClass]="groupDataFieldClasses" class="primary-collapsed">
            @for (rows of getPrimaryFieldsForGroup(group); track rows) {
            <div fxLayout="row" class="primary-row">
                <info-card-detail-field fxFlex [itemMetadata]="item.Metadata" [rows]="rows"
                    [maxWidth]="getPrimaryFieldWidth(group)" (executeCommand)="performFieldCommand($event)">
                </info-card-detail-field>
            </div>
            }
        </div>
        }
        @if (isEmphasized && hasItems(group.GroupName)) {
        <div fxLayout="column" fxLayoutAlign="space-around" class="pad-top-10">
            @for (rows of getSecondaryFieldsForGroup(group); track rows) {
            <div class="primary-row" fxLayout="row">
                <info-card-detail-field fxFlex [itemMetadata]="item.Metadata" [rows]="rows"
                    [maxWidth]="getSecondaryFieldWidth(group)" (executeCommand)="performFieldCommand($event)">
                </info-card-detail-field>
            </div>
            }
        </div>
        }
    </div>
    }

    <!-- TODO - Too much logic in this conditional, make a property with a simple name for this state... -->
    @if (isEmphasized && (isDetailTable || isDetailCustom)) {
    <div fxLayout="column" fxLayoutAlign="space-around">
        <!-- TODO - should be ignoring the @Input cardProviderId or is there some order of precedence we should be using? -->
        @if (isDetailTable) {
        <info-card-detail-table [cardProviderId]="item.CardProviderId" [itemId]="item.Id">
        </info-card-detail-table>
        }
      @if (isDetailCustom && detailTemplate) {
        <ng-container *ngTemplateOutlet="detailTemplate; context: { $implicit: item }"></ng-container>
      }
    </div>
    }

    @if (hasBarCommands) {
    <div [fxShow]="isEmphasized" fxLayout="row" fxLayoutAlign="end center" class="forge-card-footer-container"
        style="padding: 1rem;">
        <command-bar [commands]="itemCommands" (click)="$event.stopPropagation()"></command-bar>
    </div>
    }
</forge-card>